<app-header></app-header>
<div class="container-fluid bg-blogs py-24">
  <div class="container">
    <p class="text-5xl text-center font-bold text-white">Enroll</p>
    <p class="pt-8 text-4xl text-center font-bold text-white">Admissions management: Expert insights here.</p>
    <p class="text-2xl text-center text-white pt-4">Read the latest on streamlining admissions.</p>
  </div>
</div>
<div class="container-fluid mt-10 md:mt-20">
  <div class="container mx-auto px-4 py-6">
    <div class="flex flex-wrap -mx-4">
      <div *ngFor="let blog of blogs" class="w-full md:w-1/3 px-4 mb-6">
        <a href="/blog-details">
          <mat-card class="shadow-lg card-hover-effect">
            <img mat-card-image [src]="blog.image" alt="{{ blog.title }}" class="w-full h-48 object-cover">
            <mat-card-header>
              <mat-card-title>{{ blog.title }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p class="text-zinc-500 text-justify">{{ blog.content }}</p>
            </mat-card-content>
            <mat-card-actions>
              <button mat-button>Learn More</button>
            </mat-card-actions>
          </mat-card>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="above-footer container-fluid mt-10 md:mt-20">
  <div class="container py-12">
    <div class="m-auto text-center">
      <img src="./assets/images/img-group.png" alt="" class="mx-auto">
      <h3 class="mt-5 text-white text-xl font-medium">
        Need any further assistance?
      </h3>
      <p class="mt-4 text-white ">
        Feel free to reach out for any inquiries or assistance.
      </p>
      <button type="button" class="mt-5 px-3 py-2 bg-white text-[#6752A9] rounded" (click)="goTo('/contact-us')">
        Book an appointment now!
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>
